import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';

import {
	getActiveLockingIdSelector,
	getActiveRoleIdSelector,
	getLoadingProjectSelector,
	getLoadingRolesSelector,
	getLoadingLockingsSelector,
	getLoadingCylinderTypesSelector
} from '../reducers/app';

import { getCylindersTypesRequest } from './planActions';

import LoadingOverlay from '../common/components/LoadingOverlay';
import { PrimaryButton } from '../Ui';
import FAQ from '../faq';

import PlanHeadersContainer from './PlanHeadersContainer';
import LockingsButton from './LockingsButton';
import RolesContainer from './roles/RolesContainer';
import RoleFormContainer from './roles/RoleFormContainer';
import RolesAllRightsContainer from './rights/RolesAllRightsContainer';
import LockingsListContainer from './lockings/LockingsListContainer';
import LockingFormContainer from './lockings/LockingFormContainer';
import LockingsAllRightsContainer from './rights/LockingsAllRightsContainer';
import RightsTableContainer from './rights/RightsTableContainer';

class PlanRoute extends Component {
	constructor(props) {
		super(props);

		this.handleScroll = this.handleScroll.bind(this);
	}

	componentDidMount() {
		this.props.getCylindersTypesRequest();
	}

	componentWillUnmount() {
		this.props.clearPlanDatas();
	}

	render() {
		const { projectId } = this.props.params;
		return (
			<div
				className="plan"
				ref={div => (this.planDiv = div)}
				onScroll={this.handleScroll}
			>
				<LoadingOverlay show={this.props.isLoading} />

				<div
					className="plan__headers"
					ref={div => (this.headersDiv = div)}
				>
					<PlanHeadersContainer />
					<div className="plan__lockings-btn-wrapper">
						<LockingsButton projectId={projectId} />
					</div>
				</div>

				<div className="plan__roles" ref={div => (this.rolesDiv = div)}>
					<RolesContainer />
					<RolesAllRightsContainer />
				</div>

				<div
					className="plan__lockings"
					ref={div => (this.lockingsDiv = div)}
				>
					<LockingsListContainer />
					<LockingsAllRightsContainer />
				</div>

				<div className="plan__rights">
					<RightsTableContainer />
				</div>

				<RoleFormContainer />

				<div>
					<LockingFormContainer />
				</div>

				<div className="plan__actions">
					<span className="mr-1">
						<FAQ />
					</span>
					<Link
						to={
							'/app/project/' +
							encodeURIComponent(projectId) +
							'/offers'
						}
					>
						<PrimaryButton iconName="check" raised>
							Voir l'offre
						</PrimaryButton>
					</Link>
				</div>
			</div>
		);
	}

	handleScroll(event) {
		event.preventDefault();

		function setVendor(element, property, value) {
			element.style['webkit' + property] = value;
			element.style['moz' + property] = value;
			element.style['ms' + property] = value;
			element.style['o' + property] = value;
		}

		const scrollTop = this.planDiv.scrollTop;
		const scrollLeft = this.planDiv.scrollLeft;

		// const headersTranslation		= `translate(${scrollLeft}px, ${scrollTop}px)`
		// const rolesBlockTranslation		= "translateY(" + this.planDiv.scrollTop + "px)";
		// const lockingsBlockTranslation	= "translateX(" + this.planDiv.scrollLeft + "px)";

		setVendor(
			this.headersDiv,
			'Transform',
			`translate(${scrollLeft}px, ${scrollTop}px)`
		);

		setVendor(this.rolesDiv, 'Transform', `translateY(${scrollTop}px)`);

		setVendor(this.lockingsDiv, 'Transform', `translateX(${scrollLeft}px)`);

		if (
			this.planDiv.scrollLeft > 5 &&
			!this.lockingsDiv.classList.contains('shadow')
		) {
			this.lockingsDiv.classList.add('shadow');
		}

		if (this.planDiv.scrollLeft < 5) {
			this.lockingsDiv.classList.remove('shadow');
		}

		if (
			this.planDiv.scrollTop > 5 &&
			!this.rolesDiv.classList.contains('shadow')
		) {
			this.rolesDiv.classList.add('shadow');
		}

		if (this.planDiv.scrollTop < 5) {
			this.rolesDiv.classList.remove('shadow');
		}
	}
}

function mapStateToProps(state) {
	const isLoading =
		getLoadingProjectSelector(state) ||
		getLoadingRolesSelector(state) ||
		getLoadingLockingsSelector(state) ||
		getLoadingCylinderTypesSelector(state);
	return {
		isLoading
	};
}

function mapDispatchToProps(dispatch) {
	return {
		getCylindersTypesRequest: () => dispatch(getCylindersTypesRequest()),
		clearPlanDatas: () =>
			dispatch({
				type: 'CLEAR_PLAN_DATAS'
			})
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanRoute);



// WEBPACK FOOTER //
// ./src/js/plan/PlanRoute.js